import * as z from 'zod'

import { UpdateSiteVars } from '@/common/api/params/site'

export const samplingRateSchema = z.object({
  samplingRate: z.number().min(0).max(100)
})

export type SamplingRateSchemaType = z.infer<typeof samplingRateSchema>

export const convertSamplingRateSchemaToVars = (
  siteId: number,
  schema: SamplingRateSchemaType
): UpdateSiteVars => {
  return {
    site_id: siteId,
    rec_sampling_rate: schema.samplingRate
  }
}
